import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Header } from "../header";
import Footer from "../footer";
import { screenSizes } from "../../styles/theme";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main<{ fullScreen?: boolean }>`
  flex: 1;
  ${(props) => (props.fullScreen ? "padding: 0;" : "padding: 40px 80px;")}
  @media (max-width: ${screenSizes.S}px) {
    ${(props) => (props.fullScreen ? "padding: 0;" : "padding: 0 1rem;")}
  }
  background: rgba(253, 249, 238, 1);
`;

interface LayoutProps {
  children: ReactNode;
  fullScreen?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, fullScreen }) => {
  const location = useLocation();

  // code to hide header and footer for specific routes
  const noHeaderFooterRoutes = ["/dashboard"];
  const showHeaderFooter = !noHeaderFooterRoutes.includes(location.pathname);

  return (
    <LayoutContainer>
      {showHeaderFooter && <Header />}
      <Main fullScreen={fullScreen}>{children}</Main>
      {showHeaderFooter && <Footer />}
    </LayoutContainer>
  );
};

export default Layout;
